<template>
    <div class="check-wrap">
        <p>{{ label }}</p>
        <div class="check-content">
            <input class="check-input" v-model="isCheck" type="checkbox" :id="name" @input="handleInputValue" />
            <label class="check-label" :for="name">
                <span v-show="isCheck">ON</span>
                <span v-show="!isCheck">OFF</span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isCheck: false

        }
    },
    props: {
        label: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        value: {
            type: Boolean,
            required: true
        },
    },
    mounted() {
        setTimeout(() => {
            this.isCheck = this.value
        }, 1)


    },
    methods: {
        handleInputValue(e) {
            this.$emit('input-value', this.name, e.target.checked)

        }
    }
}
</script>

<style lang="scss" scoped>
.check {
    &-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 300px;
        margin-bottom: 5px;
        p {
            margin: 0;
        }
    }
    &-label {
        width: 100px;
        padding: 10px;
        background: #eaeaea;
        text-align: center;
        transition: 0.3s all;
        border-radius: $radius;
        font-weight: bold;
        span {
            transition: 0.1s all;
        }
    }
    &-input {
        display: block;
        visibility: hidden;
    }
    &-input:checked + label {
        background: $main_color;
        color: #ffffff;
        box-shadow: 0px 3px 6px #707070;
    }
}
</style>